import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// importing all the themes
import ThemeOne from "../themes/theme-one";
import ThemeTwo from "../themes/theme-two";
import ThemeThree from "../themes/theme-three";
import ThemeFour from "../themes/theme-four";
import ThemeFive from "../themes/theme-five";
import ThemeSix from "../themes/theme-six";
import BlogTwoColumn from "../components/Blogs/BlogTwoColumn";
import BlogThreeColumn from "../components/Blogs/BlogThreeColumn";
import BlogLeftSidebar from "../components/Blogs/BlogLeftSidebar";
import BlogRightSidebar from "../components/Blogs/BlogRightSidebar";
import BlogDetailsLeftSidebar from "../components/Blogs/BlogDetailsLeftSidebar";
import BlogDetailsRightSidebar from "../components/Blogs/BlogDetailsRightSidebar";
import Reviews from "../components/ReviewSection/Reviews";
import Pricing from "../components/PricingSection/Pricing";
import DownloadPage from "../components/DownloadSection/DownloadPage";
import SubscribePage from "../components/SubscribeSection/SubscribePage";
// import ThankYou from "../components/InnerSection/ThankYou";
import ThankYouPage from "../components/InnerSection/ThankYouPage";
import ComingSoon from "../components/InnerSection/ComingSoon";
import Login from "../components/Accounts/Login";
import Signup from "../components/Accounts/Signup";
import Forgot from "../components/Accounts/Forgot";
import Faq from "../components/FaqSection/Faq";
import ErrorPage from "../components/ErrorPage/404";
import ContactPage from "../components/ContactSection/ContactPage";
import Terms from "../components/PoliciesAndCodes/Terms";
import InterestRate from "../components/PoliciesAndCodes/InterestRate";
import PrivacyPolicy from "../components/PoliciesAndCodes/PrivacyPolicy";
import LoanClosurePolicy from "../components/PoliciesAndCodes/LoanClosurePolicy";
import PoliciesCodes from "../components/PoliciesAndCodes/PoliciesCodes";
import GrievancePolicy from "../components/PoliciesAndCodes/GrievancePolicy";
import FairPracticeCode from "../components/PoliciesAndCodes/FairPracticeCode";
import ReferenceContactPolicy from "../components/PoliciesAndCodes/ReferenceContactPolicy";
import ScheduleOfCharges from "../components/PoliciesAndCodes/ScheduleOfCharges";
import Features from "../components/Features/Features";
import PersonalLoansGuide from "../components/Blogs/PersonalLoansGuide";
import BlogDetails from "../components/Blogs/BlogDetails";
class MyRouts extends React.Component {
  render() {
    return (
      <div>
        <Router>
          <Switch>
            <Route exact path="/" component={ThemeOne} />
            <Route path="/theme-two" component={ThemeTwo} />
            <Route path="/theme-three" component={ThemeThree} />
            <Route path="/theme-four" component={ThemeFour} />
            <Route path="/theme-five" component={ThemeFive} />
            <Route path="/theme-six" component={ThemeSix} />
            <Route exact path="/blog" component={BlogTwoColumn} />
            <Route path="/blog-three-column" component={BlogThreeColumn} />
            <Route path="/blog-left-sidebar" component={BlogLeftSidebar} />
            <Route path="/blog-right-sidebar" component={BlogRightSidebar} />
            <Route path="/blog/:slug" component={BlogDetails} />
            <Route
              path="/blog-details-left-sidebar"
              component={BlogDetailsLeftSidebar}
            />
            <Route
              path="/blog-details-right-sidebar"
              component={BlogDetailsRightSidebar}
            />
            <Route path="/reviews" component={Reviews} />
            <Route path="/pricing" component={Pricing} />
            <Route path="/download-page" component={DownloadPage} />
            <Route path="/subscribe-page" component={SubscribePage} />
            {/* <Route path="/thank-you" component={ThankYou} /> */}
            <Route path="/thank-you" component={ThankYouPage} />
            <Route path="/coming-soon" component={ComingSoon} />
            <Route path="/login" component={Login} />
            <Route path="/signup" component={Signup} />
            <Route path="/forgot" component={Forgot} />
            <Route path="/faq" component={Faq} />
            <Route path="/error-page" component={ErrorPage} />
            <Route path="/contact-page" component={ContactPage} />
            <Route path="/termsandconditions" component={Terms} />
            <Route path="/interestrate" component={InterestRate} />
            <Route path="/privacypolicy" component={PrivacyPolicy} />
            <Route path="/loanclosurepolicy" component={LoanClosurePolicy} />
            <Route path="/policiesandcodes" component={PoliciesCodes} />
            <Route path="/grievancepolicy" component={GrievancePolicy} />
            <Route path="/fairpracticecode" component={FairPracticeCode} />
            <Route
              path="/referencecontactpolicy"
              component={ReferenceContactPolicy}
            />
            <Route path="/scheduleofcharges" component={ScheduleOfCharges} />
            <Route path="/features" component={Features} />
            <Route
              path="/blog/personal-loans-guide"
              component={PersonalLoansGuide}
            />
          </Switch>
        </Router>
      </div>
    );
  }
}
export default MyRouts;
